import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { ButtonIcon, ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const pagination: RecursivePartial<{
    defaultProps?: PaginationPresentationProps | undefined;
}> = {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            currentButton: css`
                min-height: 32px;
                height: 32px;
                width: 32px;
                padding: 4px;
                line-height: normal;
                color: ${getColor(colorStrings.commonGlobalWhite)};
            `,
            linkList: css`
                ul {
                    display: flex;
                    align-items: center;
                }

                &&&& ${ButtonWrapper} {
                    height: 32px;
                    width: 32px;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:disabled {
                        color: ${getColor(colorStrings.textDisabled)};
                        background-color: transparent;
                    }

                    &:hover {
                        &:disabled {
                            background-color: transparent;
                            border-color: transparent;
                        }
                    }

                    ${IconWrapper} {
                        height: auto;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        > svg {
                            height: 25px;
                            width: 25px;
                        }
                    }

                    &[aria-current="page"] {
                        font-weight: 700;
                        color: ${getColor(colorStrings.commonGlobalWhite)};
                    }

                    &:not([aria-current="page"]) {
                        &:not(:disabled) {
                            color: ${getColor(colorStrings.textMain)};
                            background-color: transparent;

                            ${ButtonIcon} {
                                color: ${getColor(colorStrings.primaryMain)};
                            }
                            &:hover {
                                color: ${getColor(colorStrings.commonGlobalWhite)};
                                background-color: ${getColor(colorStrings.primaryMain)};

                                ${ButtonIcon} {
                                    color: ${getColor(colorStrings.commonGlobalWhite)};
                                }
                                &[aria-label="Next page"],
                                &[aria-label="Previous page"],
                                &[aria-label="First page"],
                                &[aria-label="Last page"] {
                                    color: ${getColor(colorStrings.primaryMainContrast)};
                                    background-color: transparent;
                                    ${ButtonIcon} {
                                        color: ${getColor(colorStrings.primaryMainContrast)};
                                    }
                                }
                            }
                        }
                    }
                }
            `,
        },
        selectProps: {
            cssOverrides: {
                formField: css`
                    justify-content: center;
                    align-items: center;

                    label {
                        font-size: 18px;
                        line-height: 22px;
                        padding: 0 8px 0 0;
                    }
                `,
                inputSelect: css`
                    & + ${IconWrapper} {
                        height: 100%;
                        width: auto;
                    }
                `,
            },
        },
    },
};
